module.exports = __webpack_public_path__ + "img/headLeft6Logo.fa7b1dac.png";